module.exports = __webpack_public_path__ + "img/brygga.c6d657a5.jpg";